import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/GreenButton.module.scss'

import { Button } from 'react-bootstrap'

class GreenButton extends React.Component {

  render() {

    const { text, width, svg, action, className, addClass, href, submit, target } = this.props

    if(href != ``) return (
      <Button
        className={className != `` ? `${styles.button} ${className} ${styles[addClass]}` : `${styles.button} ${styles[addClass]}`}
        as={`a`}
        href={href}
        variant='primary'
        style={ width != 0 ? { width: `${width}px` } : {} }
        onClick={() => action()}
        target={target}
      >
        <div className={styles.button_icon}>{svg}</div>
        <div className={styles.button_text}>{text}</div>
      </Button>
    )
    if(submit) return (
      <Button
        className={className != `` ? `${styles.button} ${className} ${styles[addClass]}` : `${styles.button} ${styles[addClass]}`}
        type={`submit`}
        variant='primary'
        style={ width != 0 ? { width: `${width}px` } : {} }
        onClick={() => action()}
      >
        <div className={styles.button_icon}>{svg}</div>
        <div className={styles.button_text}>{text}</div>
      </Button>
    )
    return (
      <Button
        className={className != `` ? `${styles.button} ${className} ${styles[addClass]}` : `${styles.button} ${styles[addClass]}`}
        as={`div`}
        variant='primary'
        style={ width != 0 ? { width: `${width}px` } : {} }
        onClick={() => action()}
      >
        <div className={styles.button_icon}>{svg}</div>
        <div className={styles.button_text}>{text}</div>
      </Button>
    )
  }
}

GreenButton.propTypes = {
  text: PropTypes.string,
  width: PropTypes.number,
  svg: PropTypes.object,
  action: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  addClass: PropTypes.string,
  href: PropTypes.string,
  submit: PropTypes.bool,
  target: PropTypes.string
}

GreenButton.defaultProps = {
  text: `Отправить`,
  width: 170,
  svg: (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
    </svg>
  ),
  action: () => {
    window.console.log( `btn click` )
  },
  type: `button`,
  className: ``,
  addClass: `def`,
  href: ``,
  submit: false,
  target: ``
}

export default GreenButton